<template>
  <div class="container py-5">

    <div class="level">
      <div class="level-left buttons flex-row mb-0">
        <div class="title is-4 mr-3 ml-1">
          Projects with Defected Pieces
        </div>
      </div>
    </div>

    <article 
      v-if="!loading && installationProjects.length == 0" 
      class="message is-info is-fullwidth mt-3">
      <div class="message-body">
        There are no projects with defected pieces.
      </div>
    </article>

    <table 
      v-if="loading || installationProjects.length > 0"
      class="table is-hoverable is-clickable is-fullwidth is-responsive">

      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers" 
            :key="headerIndex">
            {{ header.label }}
          </th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length + 2" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <tbody v-if="installationProjects.length > 0">
        <tr 
          class="pointer v-centered"
          v-for="project in installationProjects"
          :key="project.project_id"
          @click="viewProjectItems(project)">
          <td 
            v-for="(header, headerIndex) in headers"
            :key="`column-${headerIndex}`"
            :data-title="header.label">
            <span v-if="helpers.isFunction(header.field)">
              {{ header.format ? header.format(header.field(project)) : header.field(project) }}
            </span>
            <span v-else>
              {{ header.format ? header.format(project[header.field]) : project[header.field] }}
            </span>
          </td>
        </tr>
      </tbody>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VProgress from '@/components/base/VProgress'

import helpers from '@/helpers'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VPagination, VProgress
  },
  data() {
    return {
      headers: [
        { label: 'Project Name', field: 'project_name' },
        { label: 'Project Address', field: 'address' }
      ],
      helpers: helpers,
      test: false
    }
  },
  computed: {
    ...mapState("installationSummary", [
      "installationProjects", "loading", "pagination", "filters"
    ]),
    ...mapState("auth", ["user"])
  },
  watch: {
    'pagination.page'(page) {
      this.getInstallationProjects({ page: page });
    },
    filters: {
      handler(filters) {
        this.getInstallationProjects(filters);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("installationSummary", [
      "getInstallationProjects"
    ]),
    ...mapMutations("installationSummary", [
      "changePage", "setFilter"
    ]),
    initialize() {
      this.setFilter({ field: 'defected_pieces', value: true });
    },
    viewProjectItems(project) {
      this.$router.push({ 
        name: 'InstallationDefectedItems', 
        query: { 
          project_id: project.project_id,
          status: 'Defected',
          per_page: 1000
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
@import '@/styles/flexbox.scss';
</style>